import { html } from 'lit';
import { RotateCcw } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-rotate-ccw')
export class PdsIconRotateCcw extends PdsIcon {
  @state()
  icon = RotateCcw;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
